// Single source for "does this route show the mobile site bottom navigation?".
// Shared by App (renders BottomBar) and Header (hides the mobile search icon,
// because the bottom nav already offers "Buscar").
const host = typeof window !== "undefined" ? window.location.hostname : "";

const NO_NAV_HOSTS = new Set([
  "catalogo.miahma.com.br",
  "painel.miahma.com.br",
  "link-grupos.miahma.com.br",
  "vagas.miahma.com.br",
  "ouvidoria.miahma.com.br",
  "cashback.miahma.com.br",
  "telapromo.miahma.com.br",
]);

export function hasSiteBottomNav(pathname: string, hostname: string = host): boolean {
  if (NO_NAV_HOSTS.has(hostname)) return false;
  if (pathname.startsWith("/produto/")) return false;
  if (pathname === "/checkout" || /^\/pedido\/[^/]+\/pix\/?$/.test(pathname)) return false;
  if (pathname.startsWith("/admin") || pathname.startsWith("/catalogo") || pathname.startsWith("/tela-promo")) return false;
  return true;
}
